import React from 'react'

import { Icon, IconName } from 'public/assets/v2/images/icons'

import { iconButtonContainer, iconButtonIcon } from './styles/IconButton.css'
import clsx from 'clsx'
import { cssClass } from '@/shared/utils'

interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconName
  color?: 'gray' | 'black'
  transparent?: boolean
  iconClassName?: string
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      icon,
      color = 'black',
      className = '',
      transparent = true,
      iconClassName,
      ...props
    },
    ref
  ) => {
    const ButtonIcon = Icon[icon]

    return (
      <button
        data-transparent={transparent}
        data-color={color}
        className={clsx([iconButtonContainer, className])}
        ref={ref}
        {...props}
      >
        <ButtonIcon className={cssClass([iconButtonIcon, iconClassName])} />
      </button>
    )
  }
)

IconButton.displayName = 'IconButton'
